import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin } from "lucide-react";
import Newsletter from "@/components/Newsletter";
import { LINKEDIN_URL } from "@/components/LinkedInFollow";

const brands = [
  { name: "WhichSchoolAdvisor.com", url: "https://whichschooladvisor.com" },
  { name: "SchoolsCompared.com", url: "https://schoolscompared.com" },
  { name: "TopSchoolsAwards.com", url: "https://topschoolsawards.com/" },
  { name: "EdinformaPlus", url: null },
  { name: "Education Intelligence Group", url: "https://educationintelligencegroup.com" },
  { name: "WhichUniversityAdvisor.com", url: null },
];

const nav = [
  { to: "/about", label: "About" },
  { to: "/brands", label: "Our Brands" },
  { to: "/solutions", label: "Solutions" },
  { to: "/advertising", label: "Ad Sizes" },
  { to: "/leadership", label: "Leadership" },
  { to: "/careers", label: "Careers" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

const Footer = () => (
  <footer data-testid="main-footer" className="bg-ink text-white">
    <div className="mx-auto max-w-[1400px] px-5 md:px-8 pt-20 pb-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-6">
          <div className="inline-flex mb-8">
            <img src="/logos/whichmedia-white2.png" alt="Which Media" className="h-10 w-auto" />
          </div>
          <p className="headline text-3xl md:text-4xl text-white max-w-md mb-8">
            Connecting families to the right education.
          </p>
          <Newsletter dark />
        </div>

        <div className="lg:col-span-3 lg:col-start-8">
          <p className="kicker mb-6">Our Brands</p>
          <ul className="space-y-3">
            {brands.map((b) => (
              <li key={b.name}>
                {b.url ? (
                  <a href={b.url} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-1.5 text-white/75 hover:text-primary transition-colors text-[15px] font-medium">
                    {b.name}
                    <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                ) : (
                  <span className="text-white/75 text-[15px] font-medium">{b.name}</span>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="kicker mb-6">Company</p>
          <ul className="space-y-3">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/75 hover:text-primary transition-colors text-[15px] font-medium">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-5">
          <p className="font-sans text-sm text-white/50">
            © {new Date().getFullYear()} Which Media · which-media.com · Dubai · London
          </p>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Which Media on LinkedIn"
            data-testid="footer-linkedin"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/20 text-white/70 hover:text-white hover:bg-primary hover:border-primary transition-colors"
          >
            <Linkedin size={16} />
          </a>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link to="/privacy" data-testid="footer-privacy" className="font-sans text-sm text-white/50 hover:text-primary transition-colors">Privacy</Link>
          <Link to="/terms" data-testid="footer-terms" className="font-sans text-sm text-white/50 hover:text-primary transition-colors">Terms</Link>
          <Link to="/cookies" data-testid="footer-cookies" className="font-sans text-sm text-white/50 hover:text-primary transition-colors">Cookies</Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-sans text-sm text-white/50 hover:text-primary transition-colors">
            CMS Login
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
